module.exports = new __parcel__URL__("product3.ac794f43.jpg").toString();